/**
 * Calculator utility functions
 * Helper functions for calculator-related operations
 */

/**
 * Calculate number of tranches based on project duration
 * One tranche for every 3 months, rounded up, plus one prepayment tranche
 * @param projectDurationMonths Project duration in months
 * @returns Number of tranches
 */
export const calculateTrancheCount = (projectDurationMonths: number): number => {
    const monthsPerTranche = 3;
    const workingTranches = Math.ceil(projectDurationMonths / monthsPerTranche);
    const prepaymentTranches = 1;
    return workingTranches + prepaymentTranches;
};

/**
 * Calculate total cost based on workshop cost and tranches
 * @param workshopCost Cost of the workshop
 * @param trancheCount Number of tranches
 * @param baseTrancheCost Cost per tranche
 * @returns Total cost
 */
export const calculateTotalCost = (
    workshopCost: number, 
    trancheCount: number, 
    baseTrancheCost: number
): number => {
    const tranchesTotal = trancheCount * baseTrancheCost;
    return workshopCost + tranchesTotal;
};

/**
 * Format duration text based on number of months
 * @param months Number of months
 * @param language Language code ('pl' or 'en')
 * @returns Formatted duration text
 */
export const formatDurationText = (months: number, language?: 'pl' | 'en'): string => {
    const lang = language || 'pl'; // Default to Polish if not specified
    
    if (lang === 'en') {
        return months === 1 ? '1 month' : `${months} months`;
    } else {
        // Polish formatting
        if (months === 1) return '1 miesiąc';
        if (months < 5) return `${months} miesiące`;
        return `${months} miesięcy`;
    }
};

/**
 * Convert project duration in months to days for API
 * @param months Duration in months
 * @returns Approximate days
 */
export const monthsToDays = (months: number): number => {
    return months * 30; // Approximate days per month
}; 